import { useState } from "react";

import ButtonLoader from "./ButtonLoader";

const UserForm = ({ user, isLoading, onSubmit }) => {
  const [fullName, setfullName] = useState(user?.fullName || '');
  const [email, setEmail] = useState(user?.email || '');

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      fullName,
      email
    };

    onSubmit(payload);
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col w-full overflow-visible"
    >
      <div className="p-4 flex flex-col gap-4">
        <label className="flex flex-col gap-1 w-full">
          Full name
          <input
            type="text"
            value={fullName}
            onChange={(e) => setfullName(e.target.value)}
          />
        </label>

        <label className="flex flex-col gap-1 w-full">
          Email

          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>

        <button
          type="submit"
          className="ase-button-primary h-[48px] w-full flex items-center justify-center"
        >
          {isLoading ? <ButtonLoader /> : 'Submit'}
        </button>
      </div>
    </form>
  )
}

export default UserForm;
